import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=353f1776"
import script from "./Setup.vue?vue&type=script&lang=js"
export * from "./Setup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('353f1776')) {
      api.createRecord('353f1776', component.options)
    } else {
      api.reload('353f1776', component.options)
    }
    module.hot.accept("./Setup.vue?vue&type=template&id=353f1776", function () {
      api.rerender('353f1776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/auth/views/Setup.vue"
export default component.exports